import { render, staticRenderFns } from "./NavPagePlugin.vue?vue&type=template&id=66dd798a&scoped=true"
import script from "./NavPagePlugin.vue?vue&type=script&lang=js"
export * from "./NavPagePlugin.vue?vue&type=script&lang=js"
import style0 from "./NavPagePlugin.vue?vue&type=style&index=0&id=66dd798a&prod&scoped=true&lang=scss"
import style1 from "./NavPagePlugin.vue?vue&type=style&index=1&id=66dd798a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd798a",
  null
  
)

export default component.exports